export const BASE_URL =
  process.env.REACT_APP_BASE_URL !== undefined
    ? process.env.REACT_APP_BASE_URL
    : "https://api.dev.tokkun.toshin-correction.com";

export const UNAUTHORIZED_STATUS_CODE = 401;
